export default "__VITE_ASSET__CmDxyBMz__"